import { SettingsActionTypes } from './constants';

interface SettingsState {
    loading: boolean;
    settings: any;
    error: any;
    message?: string;
}

const initialState: SettingsState = {
    loading: false,
    settings: [],
    error: null,
    message: '',
};

export type SettingsAction =
    | {
          type: typeof SettingsActionTypes.SETTINGS_APP_ADD;
          payload: { data: any };
      }
    | {
          type: typeof SettingsActionTypes.SETTINGS_APP_ADD_SUCCESS;
          payload: { message: string };
      }
    | {
          type: typeof SettingsActionTypes.SETTINGS_APP_ADD_ERROR;
          payload: { error: string };
      }
    | {
          type: typeof SettingsActionTypes.SETTINGS_APP_LIST;
          payload?: { data?: any };
      }
    | {
          type: typeof SettingsActionTypes.SETTINGS_APP_LIST_SUCCESS;
          payload: { message: string; data: any };
      }
    | {
          type: typeof SettingsActionTypes.SETTINGS_APP_LIST_ERROR;
          payload: { error: string };
      }
    | {
          type: typeof SettingsActionTypes.SETTINGS_APP_UPDATE_FORCE;
          payload: { data: any };
      }
    | {
          type: typeof SettingsActionTypes.SETTINGS_APP_UPDATE_FORCE_SUCCESS;
          payload: { message: string };
      }
    | {
          type: typeof SettingsActionTypes.SETTINGS_APP_UPDATE_FORCE_ERROR;
          payload: { error: string };
      }
    | {
          type: typeof SettingsActionTypes.SETTINGS_APP_DELETE;
          payload: { data: any };
      }
    | {
          type: typeof SettingsActionTypes.SETTINGS_APP_DELETE_SUCCESS;
          payload: { message: string };
      }
    | {
          type: typeof SettingsActionTypes.SETTINGS_APP_DELETE_ERROR;
          payload: { error: string };
      };

const settingsReducer = (state = initialState, action: SettingsAction): SettingsState => {
    switch (action.type) {
        // ADD
        case SettingsActionTypes.SETTINGS_APP_ADD:
            return { ...state, loading: true, error: null };
        case SettingsActionTypes.SETTINGS_APP_ADD_SUCCESS:
            return { ...state, loading: false, message: action.payload.message };
        case SettingsActionTypes.SETTINGS_APP_ADD_ERROR:
            return { ...state, loading: false, error: action.payload.error };

        // LIST
        case SettingsActionTypes.SETTINGS_APP_LIST:
            return { ...state, loading: true, error: null };
        case SettingsActionTypes.SETTINGS_APP_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                settings: action.payload.data,
                message: action.payload.message,
            };
        case SettingsActionTypes.SETTINGS_APP_LIST_ERROR:
            return { ...state, loading: false, error: action.payload.error };

        // UPDATE
        case SettingsActionTypes.SETTINGS_APP_UPDATE_FORCE:
            return { ...state, loading: true, error: null };
        case SettingsActionTypes.SETTINGS_APP_UPDATE_FORCE_SUCCESS:
            return { ...state, loading: false, message: action.payload.message };
        case SettingsActionTypes.SETTINGS_APP_UPDATE_FORCE_ERROR:
            return { ...state, loading: false, error: action.payload.error };

        // DELETE
        case SettingsActionTypes.SETTINGS_APP_DELETE:
            return { ...state, loading: true, error: null };
        case SettingsActionTypes.SETTINGS_APP_DELETE_SUCCESS:
            return { ...state, loading: false, message: action.payload.message };
        case SettingsActionTypes.SETTINGS_APP_DELETE_ERROR:
            return { ...state, loading: false, error: action.payload.error };

        default:
            return state;
    }
};

export default settingsReducer;
